export async function checkUserPlanEnrollments() {
  if (location.pathname === '/page/astronomer-certification' && skilljarUser) {
    let packages = await fetch('https://main--polite-fudge-d421b6.netlify.app/.netlify/functions/getUserPackages', {
      method: "POST",
      body: JSON.stringify(skilljarUser.id),
    }).then(res => res.json())

    let airflowFundamentals = packages.find(o => o.plan.title === 'Astronomer Certification for Apache Airflow Fundamentals + Exam');
    let dagAuthoring = packages.find(o => o.plan.title === 'Astronomer Certification DAG Authoring for Apache Airflow + Exam');
    let library = packages.find(o => o.plan.title === 'Library');
    let starterPackage = packages.find(o => o.plan.title === 'Starter Package');

    if (airflowFundamentals || library || starterPackage) {
      let fundamentalsCard = document.querySelector('a[title="Certification Exam: Airflow Fundamentals"]');
      let priceTag = fundamentalsCard.querySelector('.as-coursebox__meta-cost');
      priceTag.innerHTML = "Free";
    }

    if (dagAuthoring || library || starterPackage) {
      let dagAuthoringCard = document.querySelector('a[title="Certification Exam: DAG Authoring"]');
      let priceTag = dagAuthoringCard.querySelector('.as-coursebox__meta-cost');
      priceTag.innerHTML = "Free";
    }
  }
}
